var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBoat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 8.984375 2 A 1.0001 1.0001 0 0 0 8 3 L 8 3.171875 A 1.0001 1.0001 0 0 0 8.1796875 3.7441406 C 8.1180983 3.655854 8.2336897 3.8448895 8.3242188 4.0742188 C 8.4147476 4.303548 8.5237599 4.6182502 8.625 4.9804688 C 8.8274803 5.7049057 9 6.6278333 9 7.5 C 9 8.3721667 8.826034 9.3020135 8.6230469 10.035156 C 8.5215533 10.401728 8.4134185 10.720739 8.3222656 10.955078 C 8.2311127 11.189417 8.1185954 11.380905 8.1699219 11.304688 A 1.0001 1.0001 0 0 0 8 11.863281 L 8 12 A 1.0001 1.0001 0 0 0 9.125 12.992188 L 17.125 11.992188 A 1.0001 1.0001 0 0 0 18 11 C 18 7.3353738 15.68235 4.987833 13.509766 3.6992188 C 11.337181 2.4106043 9.1835938 2.0175781 9.1835938 2.0175781 A 1.0001 1.0001 0 0 0 8.984375 2 z M 10.568359 4.5625 C 11.166859 4.7839713 11.793876 5.0049413 12.490234 5.4179688 C 14.111319 6.3794746 15.54945 7.8407091 15.869141 10.132812 L 10.472656 10.808594 C 10.498986 10.720814 10.524991 10.661471 10.550781 10.568359 C 10.789539 9.7060027 11 8.6278333 11 7.5 C 11 6.4168081 10.795681 5.4010041 10.568359 4.5625 z M 3 14.990234 C 2.735 14.990234 2.4799687 15.095203 2.2929688 15.283203 C 2.1059688 15.471203 2 15.725234 2 15.990234 C 2 18.038234 2.5637344 19.616687 3.6777344 20.679688 C 5.1287344 22.064688 6.9660469 21.991234 6.9980469 21.990234 L 17.998047 22 L 18 22 C 21.007 22 23 17.73 23 16 C 23 15.448 22.553 15 22 15 L 3 14.990234 z",
    fill: "#000000"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoat);
export default __webpack_public_path__ + "static/media/boat.e6592f7c737a84a93a887202c654ae3f.svg";
export { ForwardRef as ReactComponent };